var map = {
	"./additionalInfoIcon.svg": 670,
	"./arrowLeftIcon.svg": 671,
	"./arrowMediumTop.svg": 672,
	"./arrowRightIcon.svg": 673,
	"./arrowRightIconSharp.svg": 674,
	"./arrowRightSmallIcon.svg": 675,
	"./arrowScalableIcon.svg": 676,
	"./arrowSelect2.svg": 677,
	"./arrowSelectIcon.svg": 678,
	"./benefit1.svg": 679,
	"./benefit2.svg": 680,
	"./benefit3.svg": 681,
	"./cardsIcon.svg": 682,
	"./copyIcon copy.svg": 683,
	"./copyIcon.svg": 684,
	"./crossIcon.svg": 685,
	"./crossIcon2.svg": 686,
	"./crossIcon3.svg": 687,
	"./crossIconSmall.svg": 688,
	"./crossSmallIcon.svg": 689,
	"./defaultCategoryIcon.svg": 690,
	"./depNumberIcon.svg": 691,
	"./elfCentralIcon.svg": 692,
	"./equalitySign.svg": 693,
	"./errorIcon.svg": 694,
	"./eyeClosedIcon.svg": 695,
	"./eyeOpenIcon.svg": 696,
	"./favoritesIcon.svg": 697,
	"./favoritesLabelIcon.svg": 698,
	"./filterDivider.svg": 699,
	"./filterIcon.svg": 700,
	"./frequencyIcon.svg": 701,
	"./fsAmountIcon.svg": 702,
	"./fullScreenIcon.svg": 703,
	"./gameIcon.svg": 704,
	"./hamburgerIcon.svg": 705,
	"./infoIcon.svg": 706,
	"./infoSymbol.svg": 707,
	"./levelBackground.svg": 708,
	"./levelBackgroundNew.svg": 709,
	"./linkIcon.svg": 710,
	"./lockIcon.svg": 711,
	"./lockSharpIcon.svg": 712,
	"./maxBonusAmountIcon.svg": 713,
	"./maxWinFsIcon.svg": 714,
	"./menu/fortuneIcon.svg": 428,
	"./menu/fortuneIconL.svg": 429,
	"./menu/helpdeskIcon.svg": 430,
	"./menu/helpdeskIconL.svg": 431,
	"./menu/homeIcon.svg": 432,
	"./menu/homeIconLarge.svg": 433,
	"./menu/jackpotIcon.svg": 434,
	"./menu/logo.svg": 435,
	"./menu/logoSmall.svg": 436,
	"./menu/loyaltyIcon.svg": 437,
	"./menu/mobileAppIcon.svg": 438,
	"./menu/profileIcon.svg": 439,
	"./menu/questIcon.svg": 440,
	"./menu/rewardLineupIcon.svg": 441,
	"./menu/searchIcon.svg": 442,
	"./menu/searchIconLarge.svg": 443,
	"./menu/signOutIcon.svg": 444,
	"./menu/star.svg": 445,
	"./menu/tournamentIcon.svg": 446,
	"./menu/tournamentLargeIcon.svg": 447,
	"./menu/vipIcon.svg": 448,
	"./menu/wheelIcon.svg": 449,
	"./menu/wheelIconL.svg": 450,
	"./menu/wheelIconMobile.svg": 451,
	"./menuIcon.svg": 715,
	"./minDepIcon.svg": 716,
	"./noTournamentIcon.svg": 717,
	"./numbers/number-1.svg": 452,
	"./numbers/number-2.svg": 453,
	"./numbers/number-3.svg": 454,
	"./numbers/number-4.svg": 455,
	"./numbers/number-5.svg": 456,
	"./numbers/number-6.svg": 457,
	"./numbers/number-7.svg": 458,
	"./numbers/number-8.svg": 459,
	"./numbers/number-9.svg": 460,
	"./numbers/number-shine-1.svg": 461,
	"./numbers/number-shine-2.svg": 462,
	"./numbers/number-shine-3.svg": 463,
	"./numbers/number-shine-4.svg": 464,
	"./numbers/number-shine-5.svg": 465,
	"./numbers/number-shine-6.svg": 466,
	"./numbers/number-shine-7.svg": 467,
	"./numbers/number-shine-8.svg": 468,
	"./numbers/number-shine-9.svg": 469,
	"./playIcon.svg": 718,
	"./polygon.svg": 719,
	"./preloaderDotsAnimation.svg": 720,
	"./preloaderSpinnerAnimation.svg": 721,
	"./presentIcon.svg": 722,
	"./promoIcon.svg": 723,
	"./recentIcon.svg": 724,
	"./search2Icon.svg": 725,
	"./search3Icon.svg": 726,
	"./sharpTickIcon copy.svg": 727,
	"./sharpTickIcon.svg": 728,
	"./smallInfoSymbol.svg": 729,
	"./smoothArrowIcon.svg": 730,
	"./successIcon.svg": 731,
	"./supportIcon.svg": 732,
	"./tag1Icon.svg": 733,
	"./tag2Icon.svg": 734,
	"./tag3Icon.svg": 735,
	"./tag4Icon.svg": 736,
	"./tickIcon.svg": 737,
	"./unverified.svg": 738,
	"./verified.svg": 739,
	"./wagerIcon.svg": 740,
	"./wagerTimeIcon.svg": 741,
	"./warningIcon.svg": 742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 669;